// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconSignIn: React.FC = () => {
    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-1071.000000, -50.000000)" fill="currentColor">
                    <g transform="translate(0.000000, 34.000000)">
                        <g transform="translate(1070.999900, 16.000000)">
                            <path d="M16.5627152,18.1682243 L7.4372848,18.1682243 C6.97688146,18.1682243 6.60206591,17.7934088 6.60206591,17.3330054 C6.60206591,15.0250861 8.47319233,13.156911 10.7781604,13.156911 L13.2218396,13.156911 C15.5268077,13.156911 17.3979341,15.0250861 17.3979341,17.3330054 C17.3979341,17.7934088 17.0231185,18.1682243 16.5627152,18.1682243 M12,5.8317757 C13.7029021,5.8317757 15.0841121,7.21298574 15.0841121,8.91588785 C15.0841121,10.61879 13.7029021,12 12,12 C10.2970979,12 8.91588785,10.61879 8.91588785,8.91588785 C8.91588785,7.21298574 10.2970979,5.8317757 12,5.8317757 M12,0 C5.37137236,0 0,5.37137236 0,12 C0,18.6256763 5.37137236,24 12,24 C18.6256763,24 24,18.6256763 24,12 C24,5.37137236 18.6256763,0 12,0"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconSignIn);
